<div class="auth-shell">
  <aside class="auth-shell__brand" aria-label="Ecossistema CLASS">
    <div class="auth-shell__brand-inner">
      <img class="auth-shell__logo" src="brands/brand.png" width="184" height="48" alt="CLASS" />
      <p class="auth-shell__product">ERPClass Cobrança</p>
      <h2 class="auth-shell__headline">Cobrança no ritmo da sua operação</h2>
      <p class="auth-shell__description">
        Títulos, disparos por e-mail e WhatsApp, histórico e templates — com a mesma conta do ecossistema CLASS.
      </p>
      <p class="auth-shell__footnote">Uma conta. Todo o ecossistema CLASS.</p>
    </div>
  </aside>
  <main class="auth-shell__panel">
    <header class="auth-shell__mobile-bar">
      <img class="auth-shell__logo auth-shell__logo--mobile" src="brands/brand.png" width="120" height="32" alt="CLASS" />
      <div>
        <p class="auth-shell__mobile-product">ERPClass Cobrança</p>
        <p class="auth-shell__mobile-headline">Cobrança no ritmo da sua operação</p>
      </div>
    </header>
    <div class="auth-shell__form">
      <h1 class="auth-shell__title">{{ title() }}</h1>
      @if (subtitle()) {
        <p class="auth-shell__subtitle">{{ subtitle() }}</p>
      }
      <ng-content />
    </div>
  </main>
</div>
